import React from 'react';
import { Locale } from '@op/opds.opux';
import { EmployeeCard } from '@op/titan.insurance-ecard-js/';

import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import Footer from './components/Footer';
import { CardLanguageContextProvider } from './context/CardLanguageContext';
import { EmployeeCardContextProvider } from './context/EmployeeCardContextProvider';

import './App.scss';
import '@op/titan.insurance-ecard-js/dist/styles.css';

const App: React.FC<{ locale: Locale }> = ({ locale }) => {
    return (
        <CardLanguageContextProvider locale={locale}>
            <ErrorBoundary>
                <EmployeeCardContextProvider>
                    <EmployeeCard />
                </EmployeeCardContextProvider>
            </ErrorBoundary>
            <Footer />
        </CardLanguageContextProvider>
    );
};

App.displayName = 'App';
export default App;
